import React from "react";
import "../../../AllComponentCSS.css";
import CodeCopyBlock from "../../../CodeCopyBlock";

const CSS_Icons = () => {
  return (
    <div className="tutorial-container">
      {/* Title */}
      <h1 className="tutorial-title">🎨 CSS Icons</h1>

      {/* Intro Gradient Box */}
      <div
        style={{
          background: "linear-gradient(135deg, #d1fae5, #bbf7d0)",
          padding: "1rem",
          borderRadius: "12px",
          marginBottom: "2rem",
          textAlign: "center",
        }}
      >
        <h2 style={{ color: "#166534", marginBottom: "0.5rem" }}>
          ✨ What are CSS Icons?
        </h2>
        <p style={{ fontSize: "1.1rem", lineHeight: "1.6" }}>
          Icons make web pages more attractive and user-friendly. With CSS, you
          can use <strong>icon fonts</strong> like Font Awesome, or add icons
          using <code>&lt;i&gt;</code> or <code>&lt;span&gt;</code> elements.
        </p>
      </div>

      {/* Icon Fonts */}
      <div className="tutorial-section">
        <h2 className="section-title">📘 Using Icon Fonts</h2>
        <p>
          The most popular way to add icons is through libraries like{" "}
          <a
            href="https://fontawesome.com/"
            target="_blank"
            className="learn-more"
          >
            Font Awesome
          </a>
          .
        </p>
        <CodeCopyBlock
          code={`<!-- Link Font Awesome in your HTML -->
<link
  rel="stylesheet"
  href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0-beta3/css/all.min.css"
/>

<!-- Example: -->
<i class="fas fa-home"></i>
<i class="fas fa-user"></i>`}
        />
        <p>
          In this example, <code>fa-home</code> shows a home icon and{" "}
          <code>fa-user</code> shows a user icon.
        </p>
      </div>

      {/* Emoji as Icons */}
      <div className="tutorial-section">
        <h2 className="section-title">😀 Using Emojis</h2>
        <p>
          You can also use emojis as icons. They are lightweight and work
          everywhere.
        </p>
        <CodeCopyBlock
          code={`<p>Home 🏠 | Profile 👤 | Settings ⚙️ | Search 🔍</p>`}
        />
        <p>Preview: Home 🏠 | Profile 👤 | Settings ⚙️ | Search 🔍</p>
      </div>

      {/* Custom Image as Icon */}
      <div className="tutorial-section">
        <h2 className="section-title">🖼️ Custom Image as an Icon</h2>
        <p>
          You can also use small images (PNG/SVG) as icons with{" "}
          <code>&lt;img&gt;</code> tags.
        </p>
        <CodeCopyBlock
          code={`<img src="https://img.icons8.com/ios-filled/50/000000/home.png" 
     alt="home" width="20" height="20" /> Home`}
        />
        <p>
          Preview:{" "}
          <img
            src="https://img.icons8.com/ios-filled/50/000000/home.png"
            alt="home"
            width="20"
            height="20"
          />{" "}
          Home
        </p>
      </div>

      {/* CSS with Pseudo-elements */}
      <div className="tutorial-section">
        <h2 className="section-title">⚡ CSS Pseudo-elements for Icons</h2>
        <p>
          You can add icons with <code>::before</code> or <code>::after</code>{" "}
          pseudo-elements.
        </p>
        <CodeCopyBlock
          code={`.home::before {
  content: "🏠";
  margin-right: 8px;
}

.profile::before {
  content: "👤";
  margin-right: 8px;
}`}
        />
        <p>
          Preview: <span className="home">Home</span> |{" "}
          <span className="profile">Profile</span>
        </p>
      </div>

      {/* Next Steps */}
      <div className="tutorial-section">
        <h2 className="section-title">🚀 Next Steps</h2>
        <p>
          After learning icons, explore{" "}
          <a href="/css/colors" className="learn-more">
            CSS Colors
          </a>{" "}
          to make them even more stylish.
        </p>
      </div>
    </div>
  );
};

export default CSS_Icons;
